<template>
  <dialog :id="id" class="mx-auto w-full lg:max-w-2xl rounded-lg shadow-lg">
    <h1 class="text-lg font-semibold p-4">Cancel this bid?</h1>
    <template v-if="bid">
      <p class="px-4">
        This bid will be withdrawn and will not be filled when the auction
        closes.
      </p>
      <div class="m-4 grid grid-cols-[3fr,1fr,1fr]">
        <p class="p-2 pl-4 font-semibold bg-boba-sand-light rounded-l-lg">
          Item
        </p>
        <p class="p-2 font-semibold bg-boba-sand-light text-right">Quantity</p>
        <p
          class="p-2 pr-4 font-semibold text-right bg-boba-sand-light rounded-r-lg"
        >
          Max Price
        </p>

        <p class="ml-2 p-2 pb-0 md:pb-2 pl-0 col-span-3 md:col-span-1">
          <span v-if="listing.subtitle">{{ listing.subtitle }}: </span>
          <span>{{ listing.title }}</span>
        </p>
        <p class="p-2 pt-0 md:pt-2 col-start-2 text-right">
          {{ bid.bid_quantity }}x
        </p>
        <p class="mr-2 p-2 pt-0 md:pt-2 pr-0 text-right">
          {{ $format(bid.bid_amount / 1e9) }} miles
        </p>
      </div>
    </template>

    <div class="flex justify-end px-4 pb-4">
      <button
        data-test="dismiss"
        @click="emit('dismiss')"
        class="min-h-[44px] px-4 py-2 mr-4 border enabled:border-boba-sand rounded-lg enabled:shadow disabled:bg-gray-100 disabled:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-boba-brown focus-visible:ring-offset-2"
        :disabled="cancelling"
      >
        Keep bid
      </button>

      <button
        data-test="confirm"
        @click="emit('confirm')"
        class="min-h-[44px] enabled:bg-red-700 enabled:text-white px-4 py-2 rounded-lg enabled:shadow disabled:bg-red-700/60 disabled:text-gray-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-700 focus-visible:ring-offset-2"
        :disabled="cancelling"
      >
        <span v-if="!cancelling">Cancel bid</span>
        <span v-else
          >Cancelling <i class="fa-solid fa-spinner fa-spin-pulse"
        /></span>
      </button>
    </div>
  </dialog>
</template>
<script lang="ts" setup>
import { Listing, ListingBid } from "@/types";

withDefaults(
  defineProps<{
    bid: ListingBid | null;
    listing: Listing;
    cancelling: boolean;
    id?: string;
  }>(),
  { id: "cancel-dialog" },
);

const emit = defineEmits(["confirm", "dismiss"]);
</script>
